import { Model } from '@vuex-orm/core'
import { find, get, filter, map, orderBy } from 'lodash'
import {getAccountDomain} from "@/constants/urls";
import UserRole from '../user-roles/model'
import { ADMIN, ENGINEER, STATUS_APPROVED, STUDENT } from '../roles/model'


export default class User extends Model {
    // This is the name used as module name of the Vuex Store.
    static get entity () {
        return 'users'
    }

    // List of all fields (schema) of the post model. `this.attr` is used
    // for the generic field type. The argument is the default value.
    static fields () {
        return {
            id: this.uid(),
            firstName: this.string('').nullable(),
            lastName: this.string('').nullable(),
            surName: this.string('').nullable(),
            email: this.string(''),
            profile_photo_path: this.string('').nullable(),

            tablenumber: this.string('').nullable(),

            userRolePivot: this.hasMany(UserRole, 'userId'),
            username: this.attr(''),
        }
    }

    get studentRole () {
        let roles = orderBy(filter(this.currentRoles, userRole => get(userRole, 'role.sysname') === STUDENT), ['isMain'], ['desc'])
        return get(roles, '0')
    }
    get positionId() {
        return get(this.studentRole, 'positionId')
    }
    get group() {
        return get(this.studentRole, 'group')
    }

    get groupId () {
        return get(this.group, 'id', null)
    }

    getOrganizationRoles(organizationId) {
        return orderBy(filter(this.currentRoles, userRole => {
            return get(userRole, 'organizationId') === organizationId
        }), ['isMain'], ['desc'])
    }

    getPositions(organizationId) {
        let roles = this.getOrganizationRoles(organizationId)
        return filter(map(roles, 'position'))
    }

    getPosition(organizationId) {
        let roles = this.getOrganizationRoles(organizationId)
        return get(roles, '0.position', null)
    }

    getPositionId(organizationId) {
        return get(this.getPosition(organizationId), 'id', null)
    }

    getGroup(organizationId) {
        let roles = orderBy(this.getOrganizationRoles(organizationId), ['groupId', 'isMain'], ['desc', 'desc'])

        return get(roles, '0.group', null)
    }

    getGroupId(organizationId) {
        return get(this.getGroup(organizationId), 'id', null)
    }

    get currentPositions () {
        return map(this.currentRoles, 'position')
    }

    get currentOrganizations () {
        return map(this.currentRoles, 'organization')
    }

    get currentRoles () {
        let user = this.$query().with([
            'userRolePivot.group',
            'userRolePivot.position',
            'userRolePivot.organization',
            'userRolePivot.role',
        ]).find(this.id)

        return filter(user.userRolePivot, userRole => userRole.status === STATUS_APPROVED)
    }

    get hasRoles () {
       return this.currentRoles.length !== 0
    }

    get hasAnyRoles () {
        return this.userRolePivot.length !== 0
    }

    get allRoleList () {
        return map(this.userRolePivot, userRole => userRole.role.name).join(', ')
    }

    get roleList () {
        return map(filter(this.userRolePivot, userRole => userRole.status === STATUS_APPROVED), role => role.name).join(', ')
    }

    get isAdmin () {
        return !!find(this.currentRoles, userRole => userRole.role.sysname === ADMIN)
    }

    get isEngineer () {
        return !!find(this.currentRoles, userRole => userRole.role.sysname === ENGINEER)
    }

    get isStudent () {
        return !!find(this.currentRoles, userRole => userRole.role.sysname === STUDENT)
    }

    get fullName () {
        return `${this.lastName} ${this.firstName}`
    }

    get photoPath () {
        if (!this.profile_photo_path) {
            return `https://ui-avatars.com/api/?name=${this.firstName}&color=7F9CF5&background=EBF4FF`
        }

        return getAccountDomain() + '/storage/' + this.profile_photo_path
    }
}
